import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ValidationProvider } from '@services/helpers/validation.service';

@Injectable()
export class ProfileUpdateServiceProvider {
	constructor(
		private messageService: MessageService,
		private validationService: ValidationProvider
	) {}

	validateName(firstName: string): boolean {
		let isValidName = true;

		firstName = firstName.trim();

		if (!firstName || firstName === '') {
			isValidName = false;
		}

		return isValidName;
	}

	isValidEmail(email: string, initialEmail: string): boolean {
		let isValidEmail = true;

		email = email.trim().toLowerCase();

		if (!email || email === '') {
			isValidEmail = false;
			this.messageService.showToaster('e_0', 'general');
		} else if (email === initialEmail) {
			isValidEmail = false;
			this.messageService.showToaster('i_2', 'profile');
		} else if (!this.validationService.isEmailValid(email)) {
			isValidEmail = false;
			this.messageService.showToaster('e_3', 'profile');
		}

		return isValidEmail;
	}

	isValidPassword(password: string, passwordConfirm: string): boolean {
		let isValidPassword = true;

		if (passwordConfirm != password) {
			this.messageService.showToaster('e_0', 'profile');
			isValidPassword = false;
		} else if (password.length < 6) {
			this.messageService.showToaster('e_1', 'profile');
			isValidPassword = false;
		} else if (password.trim().length === 0) {
			this.messageService.showToaster('e_3', 'general', 'password');
			isValidPassword = false;
		}

		return isValidPassword;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/services/profile/profile-update.service.ts